import { render, staticRenderFns } from "./DataCollectionRangeCriteriaIndividual.vue?vue&type=template&id=9a13fa2e&"
import script from "./DataCollectionRangeCriteriaIndividual.vue?vue&type=script&lang=ts&"
export * from "./DataCollectionRangeCriteriaIndividual.vue?vue&type=script&lang=ts&"
import style0 from "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./DataCollectionRangeCriteriaIndividual.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports